export default __webpack_public_path__ + "static/media/MyProperties.4d3b3053.svg";